import { Button } from "@/components/primitives";
import { calculateTotalPages } from "../utils";

interface PaginationControlsProps {
	page: number;
	setPage: (page: number) => void;
	totalCount: number;
	pageSize: number;
}

export const PaginationControls = ({
	page,
	setPage,
	totalCount,
	pageSize,
}: PaginationControlsProps) => {
	const totalPages = calculateTotalPages(totalCount, pageSize);
	const currentPage = Math.min(page + 1, totalPages);

	const handlePrevious = () => {
		setPage((page - 1 + totalPages) % totalPages);
	};

	const handleNext = () => {
		setPage((page + 1) % totalPages);
	};

	if (totalPages <= 1) return null;

	return (
		<div className="flex flex-col sm:flex-row items-center justify-between gap-4 p-4 rounded-lg bg-white/50 dark:bg-slate-800/50 backdrop-blur-sm border border-border/50">
			<div className="flex items-center gap-3">
				<h2 className="text-base sm:text-lg font-medium text-foreground">
					Your Previous Check-ins
				</h2>
				<span className="text-sm text-muted-foreground hidden sm:inline">
					Page {currentPage} of {totalPages}
				</span>
			</div>
			<div className="flex items-center gap-2">
				<Button
					size="sm"
					variant="outline"
					onClick={handlePrevious}
					disabled={currentPage === 1}
					className="min-w-[80px]"
				>
					Previous
				</Button>
				<Button
					size="sm"
					variant="outline"
					onClick={handleNext}
					disabled={currentPage === totalPages}
					className="min-w-[80px]"
				>
					Next
				</Button>
			</div>
		</div>
	);
};
